import React from 'react';
import ReactFlow, { Background, Controls, MiniMap, ReactFlowProps } from 'reactflow';
import 'reactflow/dist/style.css';

/** Shared canvas chrome; callers retain their channel-specific nodes and validation. */
export default function BuilderSurface({ children, ...props }: ReactFlowProps) {
  return <ReactFlow {...props}><Background /><MiniMap /><Controls />{children}</ReactFlow>;
}
